export default __webpack_public_path__ + "static/media/closeIcon.1b4a1556.svg";